import { Button, Flex, Text } from "@chakra-ui/react";
import { BsCameraVideo, BsMic } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";

import { MdGroupAdd } from "react-icons/md";
import useSmallScreen from "../../../../components/useSmallScreen";
import LiveStreamChat from "./LiveStreamChat";
import { useLocalParticipant } from "@livekit/components-react";
import { Track, createLocalTracks } from "livekit-client";
import { useCallback, useEffect, useRef, useState } from "react";
import Chat from "../../../../components/livekit/host-chat";
import { useNavigate } from "react-router-dom";
import { useParticipants } from "@livekit/components-react";

function LiveStreamBottomLargeScreenControls({ viewingLiveStream }) {
  const participants = useParticipants();
  const [smallScreen] = useSmallScreen();
  const navigate = useNavigate();
  const [videoTrack, setVideoTrack] = useState();
  const [audioTrack, setAudioTrack] = useState();
  const [isPublishing, setIsPublishing] = useState(false);
  const [isUnpublishing, setIsUnpublishing] = useState(false);
  const previewVideoEl = useRef(null);
  let btnStyle = {size: "xs",
  p: "15px 15px",
  fontSize: ".8em",
  borderRadius: "9px",
  bg: "#D9D9D9",
  color: "#000",
};

  const { localParticipant } = useLocalParticipant();

  const createTracks = async () => {
    const tracks = await createLocalTracks({ audio: true, video: true });
    tracks.forEach((track) => {
      switch (track.kind) {
        case Track.Kind.Video: {
          if (previewVideoEl?.current) {
            track.attach(previewVideoEl.current);
          }
          setVideoTrack(track);
          break;
        }
        case Track.Kind.Audio: {
          setAudioTrack(track);
          break;
        }
      }
    });
  };

  useEffect(() => {
    void createTracks();
  }, []);

  useEffect(() => {
    return () => {
      videoTrack?.stop();
      audioTrack?.stop();
    };
  }, [videoTrack, audioTrack]);

  const togglePublishing = useCallback(async () => {
    if (isPublishing && localParticipant) {
      setIsUnpublishing(true);

      if (videoTrack) {
        void localParticipant.unpublishTrack(videoTrack);
      }
      if (audioTrack) {
        void localParticipant.unpublishTrack(audioTrack);
      }

      await createTracks();

      setTimeout(() => {
        setIsUnpublishing(false);
      }, 2000);
    } else if (localParticipant) {
      if (videoTrack) {
        void localParticipant.publishTrack(videoTrack);
      }
      if (audioTrack) {
        void localParticipant.publishTrack(audioTrack);
      }
    }

    setIsPublishing((prev) => !prev);
  }, [audioTrack, isPublishing, localParticipant, videoTrack]);


  return (
    <Flex
      gap={["5px", "40px"]}
      flexWrap={[!viewingLiveStream ? "wrap" : "nowrap", "nowrap"]}
      flexDir={"row"}
      alignItems={["flex-end", "flex-end"]}
      position={"absolute"}
      bottom={["40px", "110px"]}
      px={viewingLiveStream ? "20px" : "unset"}
      right={viewingLiveStream ? "unset" : "20px"}
      left="0"
      w={viewingLiveStream ? "100%" : "unset"}
      justifyContent={viewingLiveStream ? "space-between" : "unset"}
    >
      <Flex
        flexDirection={"row"}
        alignItems={"flex-end"}
        w="100%"
        gap={["5px", "20px"]}
      >
          {/* <Chat /> */}
        <LiveStreamChat viewingLiveStream={viewingLiveStream} />
        {/* {viewingLiveStream && (
          <Flex
            flexDirection={"row"}
            alignItems="center"
            bg={!smallScreen ? "#5C5B5B" : "unset"}
            borderRadius={"10px"}
            p={["unset", "1px 10px"]}
            fontWeight={"600"}
            gap={["unset", "10px"]}
            color="#fff"
            cursor={"pointer"}
          >
            <MdGroupAdd fontSize={!smallScreen ? "3em" : "3em"} />
            {!smallScreen && <Text>Join Stream</Text>}
          </Flex>
        )} */}
      </Flex>

      <Flex alignItems={"flex-start"} gap={["5px", "50px"]}>
      <Flex justifyContent={'flex-start'}alignItems={"center"} gap={["5px", "10px"]}>
      <FiUsers            cursor={"pointer"}
            fontSize={"2em"}
            color={btnStyle?.bg}/>
      {participants.length}
      </Flex>
       
        {/* {!viewingLiveStream && (
          <BsCameraVideo
            cursor={"pointer"}
            fontSize={"3em"}
            color={btnStyle?.bg}
          />
        )} */}
        {/* {viewingLiveStream ? (
          <Button {...btnStyle} p="20px 15px" color="#fff" bg="#FF2121">
            Leave
          </Button>
        ) : (
          <Flex gap={"20px"} flexDir={"row"} alignItems="center">
            <Button {...btnStyle}>Record</Button>
            <Button {...btnStyle}>Share screen</Button>
            <Button {...btnStyle} color="#fff" bg="#FF2121">
              End
            </Button>
          </Flex>
        )} */}
               {/* <Button     onClick={() =>
            navigate("/live-streaming")
          }{...btnStyle} color="#fff" bg="#FF2121">
              Leave
            </Button> */}
 
      </Flex>
    </Flex>
  );
}

export default LiveStreamBottomLargeScreenControls;
